// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-data-select-cluster-no-data-select-ef74d{align-items:center;display:flex;flex-direction:column;height:240px;justify-content:center;width:100%}.no-data-select-cluster-no-data-select-ef74d img{height:100px;margin-top:-30px;width:100px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"no-data-select": "no-data-select-cluster-no-data-select-ef74d",
	"noDataSelect": "no-data-select-cluster-no-data-select-ef74d"
};
export default ___CSS_LOADER_EXPORT___;
